import React from "react";
import Layout from "app/layout/Layout";
import Homepage from "./Homepage";
import MainMenu from "app/MainMenu";
import Footer from "app/Footer";
import styled from "styled-components";
import { keyframes } from "styled-components";
import bg_src from "app/resources/bg-large.jpg";
import logo_src from "app/resources/logo.png";
import { NavLink } from "react-router-dom";
import { injectIntl } from "react-intl";

const returnFalse = () => false;

const Banner = ({ clickable, compact, ...props }) => {
  const urlSearch = window.location.search;
  return clickable ? (
    <NavLink to={"/" + urlSearch} {...props} isActive={returnFalse}>
      <img src={logo_src} alt="Smarticipate" />
    </NavLink>
  ) : (
    <div {...props}>
      <img src={logo_src} alt="Smarticipate" />
    </div>
  );
};

const blur = keyframes`
  from {
    filter: blur(10px);
    transform: scale(2);
  }
  to {
    filter: blur(0px);
    transform: translateY(-20%), scale(1);
  }
`;

// > 100*(φ^(1/4))^(-5:0)
// [1]  54.79809  61.80340  69.70425  78.61514  88.66518 100.00000
// > 100-100*(φ^(1/4))^(-5:0)
// [1] 45.20191 38.19660 30.29575 21.38486 11.33482  0.00000

export const StyledBanner = styled(Banner).attrs({
  clickable: true
})`
  display: flex;
  height: ${props => (props.compact ? "11.33vh" : "30.3vh")};
  background: url(${bg_src}) no-repeat center 0px;
  background-size: cover;
  & img {
    margin: auto;
    max-height: ${props => (props.compact ? "61.8%" : "45.2%")};
    max-width: 78.62vw;
    transform: translateY(-15%);
    ${props => (props.compact ? null : `_animation: ${blur} 0.5s ease 1;`)};
  }
  @media (max-aspect-ratio: 1/1) {
  }
`;

export default injectIntl(props => {
  return (
    <Layout
      banner={<StyledBanner clickable={false} />}
      navbar={<MainMenu />}
      main={<Homepage intl={props.intl} />}
      footer={<Footer />}
    />
  );
});



// WEBPACK FOOTER //
// ./src/app/home/index.js